import { Grid, Typography } from "@mui/material";
import { useSuperAdminOrganization } from "../../context/SuperAdmin/OrganizationContext";
import { Spinner } from "../../components/Loading/Spinner";
import OrganizationPanel from "../../components/Table/Organization/OrganizationPanel";

export const OrganizationPage = () => {
  const { isLoadingOrgs } = useSuperAdminOrganization();

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
      }}
    >
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Cuentas administradas</b> | Organizaciones
        </Typography>
      </Grid>

      {isLoadingOrgs ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <OrganizationPanel />
      )}
    </Grid>
  );
};
